module.exports = kolibriCoreAppGlobal.lib.vuex;